// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
export const getCredential = state => state.loginReducer.credential;
export const getCommonError = state => state.loginReducer.commonError;
